import { DictList } from '@/shared';

export const MORTGAGE_STAGE_LABELS = Object.freeze({
  app_create: 'Создана',
  app_wait: 'Ожидание',
  app_wait_accept: 'Предварительно одобрен',
  app_bank_note: 'Возврат',
  app_complete_accept: 'Одобрен',
  app_complete_decline: 'Отказ',
  app_ending: 'Работа с Банком',
  app_issued: 'Выдан',
  app_cancel: 'Отменена'
});

export const MORTGAGE_STAGE_LABELS_DICT: Readonly<DictList> = [
  {
    code: 'app_create',
    title: 'Создана'
  },
  {
    code: 'app_wait',
    title: 'Ожидание'
  },
  {
    code: 'app_ending',
    title: 'Работа с Банком'
  },
  {
    code: 'app_wait_accept',
    title: 'Предварительно одобрен'
  },
  {
    code: 'app_issued',
    title: 'Выдан'
  },
  {
    code: 'app_cancel',
    title: 'Отменена'
  },
  {
    code: 'app_complete_decline',
    title: 'Отказ'
  },
  {
    code: 'app_complete_accept',
    title: 'Одобрен'
  },
  {
    code: 'app_bank_note',
    title: 'Возврат'
  }
];
